
import { useState } from "react";
import { useModalesStore } from "../../../store";
import { BuscadorSoloValor, CargandoMedio, ModalFormUno } from "../../components";
import { useQueryClient } from "@tanstack/react-query";
import { DisenioConFuncion } from "../../layout";
import { useCheckData, useItemsCompraQuery, useValidarRoles } from '../../../hooks';
import { FormularioSolicitudes, TablaItemsCompra } from '../../components/facturas';
import { BotonesGroup } from "../../components";
import { startDeleteItemsCompra, startSavingOrdenCompra } from "../../../services";

import Swal from "sweetalert2";




export const ListadoSolicitudes = () => {


    const queryClient = useQueryClient();
    const { changeEstadoModalUno } = useModalesStore(); 
    const { data, isLoading, termino, chageTermino } = useItemsCompraQuery();
    const { isRolPermitido } = useValidarRoles();
    const { selected, handleSelectAllClick, handleClick, isSelected } = useCheckData(data || []);
    const isValido = (selected.length < 1);
    const [cargando, setCargando] = useState(false)


    const handleEnviarInfo = async() => {
        setCargando(true);
        const resp = await startSavingOrdenCompra(selected);
        setCargando(true);
        if( resp ){ queryClient.invalidateQueries({queryKey: ['items-compra']}) }
    }



    const handleEliminarItems = async() => {
        const result = await Swal.fire({
            title: `Eliminar Items Compra`,
            text: `¿Esta seguro de eliminar estos items?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si`,
            cancelButtonText: 'Cancelar'
        });
        if (!result.isConfirmed) return;

        const resp = await startDeleteItemsCompra(selected);
        if(resp){ queryClient.invalidateQueries({queryKey: ['items-compra']}); }
    }


    const botonesOpciones = [
        { label: "Crear Orden", onClick: handleEnviarInfo, icono:'save', disabled:isValido },
        { label: "Eliminar Items", onClick: handleEliminarItems, icono:'eliminar', color:'red', disabled:isValido },
    ];



    return (

        <DisenioConFuncion titulo="Listado de Solicitudes" handleFuncion={() => changeEstadoModalUno(true)} padding={4} scrollY={true}>
            {( isLoading )
            ?   <CargandoMedio titulo="Cargando Información de items" />

            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} titulo='Buscar nota...' place='Buscar x producto...' />

                {(isRolPermitido(['SUPERADMIN', 'ADMIN', 'SECRETARIA']) && data?.length > 0) &&
                <BotonesGroup botonesOpciones={botonesOpciones} disabled={cargando} />
                }

                <TablaItemsCompra 
                    data={data || []} 
                    selected={selected} 
                    // chagePage={ chagePage } page={ page }
                    handleSelectAllClick={ handleSelectAllClick } 
                    handleClick={ handleClick } 
                    isSelected={ isSelected }
                />
                </>
            }
            

            <ModalFormUno titulo={`Crear Solicitud`} valor={{}} onClose={() => changeEstadoModalUno(false)}>
                <FormularioSolicitudes />
            </ModalFormUno>
        </DisenioConFuncion>
    )
}
